import { ActivityIndicator, View } from 'react-native'
import designTokens from '~/lib/designTokens'
import { cn } from '~/lib/utils.ts'

export function LoadingView({ className }: { className?: string }) {
  return (
    <View className={cn('flex-1 items-center justify-center', className)}>
      <ActivityIndicator size="large" color={designTokens.foreground} />
    </View>
  )
}

export function LoadingOverlay({ className }: { className?: string }) {
  return (
    <View
      className={cn('absolute inset-0 z-50 items-center justify-center bg-primary/50', className)}
      style={{ pointerEvents: 'auto' }}>
      <ActivityIndicator size="large" color={designTokens.tertiary} />
    </View>
  )
}
